export async function handleCauseDelete(cause, setCauses, userId) {
  try {
    // Use offline-first data service for deleting cause
    const { CauseService } = await import("../../services/CauseService");

    const result = await CauseService.deleteCause(cause.id, userId);

    if (!result.success) {
      throw new Error(result.error || "Failed to delete cause");
    }

    // Update local state
    setCauses((prev) => prev.filter((m) => m.id !== cause.id));
  } catch (error) {
    console.error("Failed to delete cause:", error);
  }
}
